/** @jsxImportSource @emotion/react */
import React from 'react';
import { jsx, css } from '@emotion/react';
import { gridSize } from '../../../components/theme/constants';
import { ButtonGroup } from '@atlaskit/button';
import Button from "../../../components/button";
import { FormattedMessage } from 'components/i18n';
import { FormRenderProps } from 'react-final-form';
import { useNavigate } from 'react-router';
import { PageWrapper } from '../../../components/page';
import InlineMessage from '@atlaskit/inline-message';
import { FormSpy } from '../../../components/form';
import { RecurringSale, Sale } from '../types';
import { DateTime } from 'luxon';

interface Props extends FormRenderProps<any> {
  isSaving: boolean;
  isActive?: boolean;
  lastInvoiceDate?: string;
  onRemove: () => void;
  isNew?: boolean;
}

const RecurringSaleEditFooter: React.FC<Props> = (props) => {
  const navigate = useNavigate();

  const { form, isSaving, isActive, lastInvoiceDate, onRemove, isNew } = props;
  console.log('lastInvoiceDate',lastInvoiceDate);
  return (
    <div css={css`margin-top: 2rem;`}>
      <FormSpy<RecurringSale> subscription={{ values: true }}>
        {({ values: { startDate, lastInvoiceDate } }) => {

          if(startDate && !isActive && !lastInvoiceDate && DateTime.fromISO(startDate).startOf('day') <= DateTime.local().startOf('day')) {
            return <InlineMessage
              type="warning"
              secondaryText={<FormattedMessage
            id="sale.RecurringSaleEditPage.warnings.sendDirectly.title"
            defaultMessage="The first invoice will be send directly when you save and activate"
            />}
            >
              <FormattedMessage
                id="sale.RecurringSaleEditPage.warnings.sendDirectly.details"
                defaultMessage="Recurring invoices with a start date of today or earlier will be send directly when activated.
                If you don't want to send this invoice now click on save as draft."
              />
            </InlineMessage>
          }
          return null;
        }}
      </FormSpy>
      <div
        css={css`
          margin-top: ${gridSize() * 4}px;
        `}
      >
        <ButtonGroup>
          {isActive ?
            <Button
              appearance="primary"
              type="submit"
              isLoading={isSaving}
              onClick={() => {
                form.submit();
              }}
            >
              <FormattedMessage
                id="common.save"
                defaultMessage="Save"
              />
            </Button>
            : [<Button
              appearance="primary"
              type="submit"
              isLoading={isSaving}
              onClick={() => {
                form.change('action', 'saveActivate');
                form.change('isActive', true);
                form.submit();
              }}
            >
              <FormattedMessage
                id="sale.RecurringSaleEditFooter.saveActivate"
                defaultMessage="Save and activate"
              />
            </Button>,
          <Button
            appearance={'default'}
            type="submit"
            isLoading={isSaving}
            onClick={() => {
              form.change('action', 'saveDraft');
              form.submit();
            }}
          >
            <FormattedMessage
              id="sale.RecurringSaleEditFooter.saveDraft"
              defaultMessage="Save as draft"
            />
          </Button>]
          }
          <Button appearance="subtle" onClick={() => navigate(-1)}>
            <FormattedMessage id="common.cancel" defaultMessage="Cancel" />
          </Button>
          {!isNew && !lastInvoiceDate &&
            <Button appearance="subtle" onClick={onRemove}>
              <FormattedMessage  id="common.delete" defaultMessage="Delete" />
            </Button>}
        </ButtonGroup>
      </div>
    </div>
  );
};

export default RecurringSaleEditFooter;
